/* eslint-disable max-len */
/* eslint-disable no-case-declarations */
import * as inventoryTypes from '../types/inventoryTypes';
import initialState from './initialState';
import { updateObject } from 'utils';

const inventory = (state = initialState.inventoryTransfers, action) => {
  switch (action.type) {
    case inventoryTypes.GET_INVENTORY_TRANSFERS_START:
      return updateObject(state, { isLoading: true });

    case inventoryTypes.GET_INVENTORY_TRANSFERS_SUCCESS:
      return updateObject(state, { ...action.payload, isLoading: false });

    case inventoryTypes.GET_INVENTORY_TRANSFERS_FAILURE:
      return updateObject(state, { isLoading: false });

    case inventoryTypes.UPDATE_INVENTORY_TRANSFER_START:
      return updateObject(state, { isSaving: true });

    case inventoryTypes.UPDATE_INVENTORY_TRANSFER_SUCCESS:
      const updatedDocs = [...state.docs].map(doc => {
        if (doc._id === action.payload._id) {
          return action.payload;
        }
        return doc;
      });
      return updateObject(state, { isSaving: false, docs: updatedDocs });

    case inventoryTypes.UPDATE_INVENTORY_TRANSFER_FAILURE:
      return updateObject(state, { isSaving: false });

    case inventoryTypes.CREATE_INVENTORY_TRANSFER_SUCCESS:
      const newDocs = [action.payload, ...state.docs];
      return updateObject(state, { isLoading: false, docs: newDocs });

    default:
      return { ...state };
  }
};

export default inventory;
